import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'demo-radio-inline',
    templateUrl: 'inline.html'
})

export class DemoRadioInlineComponent implements OnInit {
    constructor() { }

    ngOnInit() { }

    value: string = '4'
}